import { useRef, useState } from "react";
import { useBoolean } from "react-use";
import { t } from "@/i18n-js/instance";
import {
  useCurrentCommunityContext,
  usePunditUserContext,
} from "@circle-react/contexts";
import { isCommunityAdmin } from "@circle-react/helpers/communityMemberHelpers";
import { useHomePageApi } from "@circle-react/hooks/home_page/useHomePageApi";
import { useUpdateCommunity } from "@circle-react/hooks/useUpdateCommunity";
import { useToast } from "@circle-react-shared/uikit/ToastV2";

export const useManageFeedActionsV3 = () => {
  const [shouldShowCoverImageModal, toggleCoverImageModal] = useBoolean(false);
  const [shouldShowCustomizeModal, toggleCustomizeModal] = useBoolean(false);
  const [isCoverImageLoading, setCoverImageLoading] = useState(false);
  const initialSectionRef = useRef(t("home_page.welcome_banner"));
  const { error } = useToast();
  const { mutateAsync: updateCommunity } = useUpdateCommunity();
  const { fetchBannerData } = useHomePageApi();

  const {
    currentCommunityMember,
    data,
    refetch: refetchPunditUser,
  } = usePunditUserContext();

  const shouldShowCustomizeHome =
    currentCommunityMember && isCommunityAdmin(currentCommunityMember);

  const {
    record: { home_page_cover_image },
    actions: { refresh },
    helpers: { isDataRefreshing },
  } = useCurrentCommunityContext();

  const coverImage = home_page_cover_image || "";

  const toggleCustomizeModalWithSection = (section: string) => {
    initialSectionRef.current = section;
    toggleCustomizeModal();
  };

  const onAddCoverImage = async (formValues: { cover_image: string }) => {
    try {
      setCoverImageLoading(true);
      await updateCommunity({
        community: { home_page_cover_image: formValues.cover_image },
      });
      await refresh();
      await refetchPunditUser();
      await fetchBannerData();
      setCoverImageLoading(false);
    } catch {
      error(t("something_went_wrong"));
      setCoverImageLoading(false);
    }
  };

  return {
    coverImage,
    shouldShowCustomizeHome,
    shouldShowCoverImageModal,
    shouldShowCustomizeModal,
    isCoverImageLoading,
    displayWelcomeBanner: !!data?.display_welcome_banner,
    initialSectionRef,
    toggleCoverImageModal,
    toggleCustomizeModal,
    toggleCustomizeModalWithSection,
    onAddCoverImage,
    isDataRefreshing,
  };
};
